import {
  Phone,
  FileText,
  Hammer,
  CheckCircle,
  Wrench,
  Building2,
  ClipboardList,
  Handshake,
} from 'lucide-react';

const ICON_MAP = {
  phone: Phone,
  'file-text': FileText,
  hammer: Hammer,
  'check-circle': CheckCircle,
  wrench: Wrench,
  building2: Building2,
  clipboard: ClipboardList,
  handshake: Handshake,
};

export function resolveHowItWorksIcon(slug = 'phone') {
  return ICON_MAP[slug] || Phone;
}
